export default {"src":"/_next/static/media/CNX.e7c1ea30.svg","height":18,"width":18};